/* =========================================================
   7 A.M. — Colección con facetas
   ---------------------------------------------------------
   El filtrado y el orden son reales, calculados en cliente sobre
   las tarjetas que ya vienen renderizadas del servidor. Los
   recuentos, el estado vacío y el "cargar más" se comportan de
   verdad en lugar de estar dibujados.

   Las tarjetas las pinta Liquid, no este script: así el marcado
   vive en un solo sitio (card-product-7am), las imágenes pasan
   por image_url y la página sigue teniendo contenido sin
   JavaScript. Aquí solo se muestran, se ocultan y se reordenan.

   Cada tarjeta llega con sus valores de faceta en data-*, que la
   sección deriva de los metacampos del producto.
   ========================================================= */
(function () {
  "use strict";

  var CAP = 6; // filas visibles por faceta antes del "ver más"

  function parseList(value) {
    if (!value) return [];
    return value
      .split("|")
      .map(function (v) {
        return v.trim();
      })
      .filter(Boolean);
  }

  function CollectionFacets(root) {
    this.root = root;
    this.items = Array.prototype.slice.call(
      root.querySelectorAll("[data-cf-item]")
    );
    this.perPage = parseInt(root.dataset.perPage, 10) || 12;
    this.shown = this.perPage;
    this.sort = "manual";

    // Los grupos los declara la sección, para que añadir uno sea un cambio
    // de Liquid y no de JavaScript.
    this.groups = Array.prototype.slice
      .call(root.querySelectorAll("[data-facet]"))
      .map(function (el) {
        return el.dataset.facet;
      });

    this.sel = this.readUrl();
    this.bind();
    this.syncInputs();
    this.render();
  }

  // Shopify pone las facetas activas en la query string, que es lo que hace
  // enlazable una colección filtrada. Leerlas de vuelta al cargar es además
  // lo único que hace alcanzable el estado vacío: por el raíl nunca lo es,
  // porque una faceta sin resultados se deshabilita antes de poder marcarla.
  CollectionFacets.prototype.readUrl = function () {
    var out = {};
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf("filter.") !== 0) return;
      var g = k.slice(7);
      (out[g] = out[g] || []).push(v);
    });
    return out;
  };

  CollectionFacets.prototype.writeUrl = function () {
    var q = new URLSearchParams();
    Object.keys(this.sel).forEach(function (g) {
      this.sel[g].forEach(function (v) {
        q.append("filter." + g, v);
      });
    }, this);
    var s = q.toString();
    history.replaceState(null, "", s ? "?" + s : location.pathname);
  };

  CollectionFacets.prototype.valuesOf = function (item, group) {
    return parseList(item.dataset["cf" + group.charAt(0).toUpperCase() + group.slice(1)]);
  };

  // `skip` deja fuera un grupo del cálculo: los recuentos respetan a los
  // otros grupos pero no al propio, así que marcar "Lavado" no pone a cero
  // el resto de Proceso. Es el comportamiento estándar de Shopify.
  CollectionFacets.prototype.matches = function (item, skip) {
    return this.groups.every(function (g) {
      if (g === skip) return true;
      var picked = this.sel[g] || [];
      if (!picked.length) return true;
      var vals = this.valuesOf(item, g);
      return picked.some(function (v) {
        return vals.indexOf(v) !== -1;
      });
    }, this);
  };

  CollectionFacets.prototype.bind = function () {
    var self = this;

    this.root.addEventListener("change", function (e) {
      var input = e.target.closest("[data-facet-value]");
      if (!input) return;
      self.toggle(input.dataset.facetGroup, input.dataset.facetValue);
    });

    this.root.addEventListener("click", function (e) {
      var head = e.target.closest(".facet__head");
      if (head) {
        head.parentElement.classList.toggle("is-open");
        return;
      }
      var more = e.target.closest(".facet__more");
      if (more) {
        var facet = more.closest(".facet");
        facet.classList.toggle("is-expanded");
        self.renderFacetCaps();
        return;
      }
      var chip = e.target.closest("[data-chip-group]");
      if (chip) {
        self.toggle(chip.dataset.chipGroup, chip.dataset.chipValue);
        return;
      }
      if (e.target.closest("[data-cf-clear]")) {
        self.clear();
        return;
      }
      if (e.target.closest("[data-cf-more]")) {
        self.shown += self.perPage;
        self.render();
        return;
      }
      if (e.target.closest("[data-cf-open]")) {
        self.setRail(true);
        return;
      }
      if (e.target.closest("[data-cf-close]") || e.target.closest("[data-cf-scrim]")) {
        self.setRail(false);
      }
    });

    var sortEl = this.root.querySelector("[data-cf-sort]");
    if (sortEl) {
      sortEl.addEventListener("change", function () {
        self.sort = sortEl.value;
        self.render();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") self.setRail(false);
    });
  };

  CollectionFacets.prototype.setRail = function (open) {
    var rail = this.root.querySelector(".crail");
    var scrim = this.root.querySelector(".crail__scrim");
    if (rail) rail.classList.toggle("is-open", open);
    if (scrim) scrim.classList.toggle("is-open", open);
    // Abrir la hoja bloquea el scroll del cuerpo detrás.
    document.body.style.overflow = open ? "hidden" : "";
  };

  CollectionFacets.prototype.toggle = function (group, value) {
    var cur = this.sel[group] || [];
    var next =
      cur.indexOf(value) !== -1
        ? cur.filter(function (v) {
            return v !== value;
          })
        : cur.concat([value]);
    if (next.length) this.sel[group] = next;
    else delete this.sel[group];
    this.shown = this.perPage;
    this.syncInputs();
    this.render();
  };

  CollectionFacets.prototype.clear = function () {
    this.sel = {};
    this.shown = this.perPage;
    this.syncInputs();
    this.render();
  };

  CollectionFacets.prototype.syncInputs = function () {
    var self = this;
    this.root.querySelectorAll("[data-facet-value]").forEach(function (input) {
      var picked = self.sel[input.dataset.facetGroup] || [];
      input.checked = picked.indexOf(input.dataset.facetValue) !== -1;
    });
  };

  // Una faceta con una fila por nota de cata llega a una docena de entradas y
  // deja el raíl más alto que la rejilla que filtra. Se muestran las primeras
  // seis y todo lo ya marcado, para que un chip siempre tenga su contrapartida
  // en el raíl.
  CollectionFacets.prototype.renderFacetCaps = function () {
    this.root.querySelectorAll(".facet").forEach(function (facet) {
      var rows = Array.prototype.slice.call(facet.querySelectorAll(".facet__row"));
      var more = facet.querySelector(".facet__more");
      var expanded = facet.classList.contains("is-expanded");
      var hidden = 0;

      rows.forEach(function (row, i) {
        var input = row.querySelector("[data-facet-value]");
        var keep = expanded || i < CAP || (input && input.checked);
        row.hidden = !keep;
        if (!keep) hidden++;
      });

      if (!more) return;
      if (expanded && rows.length > CAP) {
        more.hidden = false;
        more.textContent = more.dataset.less;
      } else if (hidden > 0) {
        more.hidden = false;
        more.textContent = more.dataset.more.replace("%d", hidden);
      } else {
        more.hidden = true;
      }
    });
  };

  CollectionFacets.prototype.render = function () {
    var self = this;

    // 1. Recuentos por faceta, cada uno ignorando su propio grupo.
    this.root.querySelectorAll("[data-facet-value]").forEach(function (input) {
      var group = input.dataset.facetGroup;
      var value = input.dataset.facetValue;
      var count = self.items.filter(function (item) {
        return (
          self.matches(item, group) && self.valuesOf(item, group).indexOf(value) !== -1
        );
      }).length;

      var row = input.closest(".facet__row");
      var countEl = row.querySelector(".facet__count");
      if (countEl) countEl.textContent = count;
      // Sin resultados se deshabilita, pero se queda visible y legible.
      row.classList.toggle("is-empty", count === 0);
      input.disabled = count === 0 && !input.checked;
    });

    this.renderFacetCaps();

    // 2. Qué tarjetas pasan el filtro.
    var visible = this.items.filter(function (item) {
      return self.matches(item, null);
    });

    // 3. Orden. Por defecto los agotados se hunden al final.
    var num = function (item, key) {
      return parseFloat(item.dataset[key] || "0") || 0;
    };
    var out = function (item) {
      return item.dataset.cfOut === "true" ? 1 : 0;
    };
    var sorted = visible.slice();
    if (this.sort === "price-asc") sorted.sort(function (a, b) { return num(a, "cfAmount") - num(b, "cfAmount"); });
    else if (this.sort === "price-desc") sorted.sort(function (a, b) { return num(b, "cfAmount") - num(a, "cfAmount"); });
    else if (this.sort === "score-desc") sorted.sort(function (a, b) { return num(b, "cfScore") - num(a, "cfScore"); });
    else sorted.sort(function (a, b) { return out(a) - out(b); });

    var grid = this.root.querySelector(".cgrid");
    sorted.forEach(function (item) {
      grid.appendChild(item);
    });

    // 4. Mostrar, ocultar y paginar.
    this.items.forEach(function (item) {
      item.hidden = true;
    });
    sorted.slice(0, this.shown).forEach(function (item) {
      item.hidden = false;
    });

    // 5. Recuentos, chips y estado vacío.
    var total = sorted.length;
    this.root.querySelectorAll("[data-cf-count]").forEach(function (el) {
      el.textContent = total;
    });
    this.root.querySelectorAll("[data-cf-word]").forEach(function (el) {
      el.textContent = total === 1 ? el.dataset.one : el.dataset.many;
    });

    var empty = this.root.querySelector(".cempty");
    if (empty) empty.hidden = total > 0;
    if (grid) grid.hidden = total === 0;

    var more = this.root.querySelector(".cgrid__more");
    if (more) {
      more.hidden = this.shown >= total;
      var progress = more.querySelector("[data-cf-progress]");
      if (progress) progress.textContent = Math.min(this.shown, total);
      var fill = more.querySelector(".cgrid__fill");
      if (fill) {
        fill.style.transform =
          "scaleX(" + (total ? Math.min(1, this.shown / total) : 1) + ")";
      }
    }

    this.renderChips();
    this.writeUrl();
  };

  CollectionFacets.prototype.renderChips = function () {
    var wrap = this.root.querySelector(".ctoolbar__chips");
    if (!wrap) return;
    var self = this;
    var clearChip = wrap.querySelector(".fchip--clear");
    wrap.querySelectorAll(".fchip:not(.fchip--clear)").forEach(function (c) {
      c.remove();
    });

    var n = 0;
    Object.keys(this.sel).forEach(function (group) {
      self.sel[group].forEach(function (value) {
        var input = self.root.querySelector(
          '[data-facet-group="' + group + '"][data-facet-value="' + CSS.escape(value) + '"]'
        );
        var label = input
          ? input.closest(".facet__row").querySelector(".facet__label").textContent.trim()
          : value;
        var chip = document.createElement("button");
        chip.type = "button";
        chip.className = "fchip";
        chip.dataset.chipGroup = group;
        chip.dataset.chipValue = value;
        chip.innerHTML =
          '<span></span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" ' +
          'stroke="currentColor" stroke-width="2.2" stroke-linecap="round" ' +
          'stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/>' +
          '<line x1="6" y1="6" x2="18" y2="18"/></svg>';
        chip.firstChild.textContent = label;
        wrap.insertBefore(chip, clearChip);
        n++;
      });
    });

    if (clearChip) clearChip.hidden = n === 0;
    var badge = this.root.querySelector(".ctoolbar__badge");
    if (badge) {
      badge.hidden = n === 0;
      badge.textContent = n;
    }
  };

  function init() {
    document.querySelectorAll("[data-collection-facets]").forEach(function (root) {
      if (root.dataset.cfReady) return;
      root.dataset.cfReady = "1";
      new CollectionFacets(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // El editor de temas re-renderiza secciones sin recargar la página.
  document.addEventListener("shopify:section:load", init);
})();
